document.addEventListener('DOMContentLoaded', function () {
  var header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('scrolled', window.scrollY > 60);
    }, { passive: true });
  }

  var menu = document.getElementById('mobile-menu');
  var hamburger = document.getElementById('hamburger');
  var menuClose = document.getElementById('menu-close');
  if (menu && hamburger) {
    hamburger.addEventListener('click', function () { menu.classList.add('open'); });
    if (menuClose) menuClose.addEventListener('click', function () { menu.classList.remove('open'); });
    menu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { menu.classList.remove('open'); });
    });
  }

  document.querySelectorAll('[data-slideshow]').forEach(function (root) {
    var track = root.querySelector('[data-slides]');
    var dots = [].slice.call(root.querySelectorAll('.sdot'));
    var total = dots.length;
    if (!track || total === 0) return;
    var cur = 0, timer;
    function render() {
      track.style.transform = 'translateX(-' + (cur * (100 / total)) + '%)';
      dots.forEach(function (d, i) {
        d.style.width = i === cur ? '26px' : '9px';
        d.style.background = i === cur ? '#EDE7D8' : 'rgba(237,231,216,0.4)';
      });
    }
    function go(i) { cur = ((i % total) + total) % total; render(); restart(); }
    function restart() { clearInterval(timer); timer = setInterval(function () { go(cur + 1); }, 5000); }
    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { go(cur - 1); });
    if (next) next.addEventListener('click', function () { go(cur + 1); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
    render();
    restart();
  });
});
